import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { LS, StorageService } from '../../core/storage/storage.service';
import { LoggingService } from '../../core/utils/logging.service';
import { DexieIndexedDBService, IPreferences } from '../../core/services/dexie-indexed-db.service';
import { defer, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageConfigService {
  private translocoService = inject(TranslocoService);
  private storageService = inject(StorageService);
  private readonly loggingService = inject(LoggingService);
  private readonly dexieDBService = inject(DexieIndexedDBService);

  constructor() {
    this.loggingService.log('@@@ Lang Service @@@');
  }

  getLangState() {
    return this.storageService.get(LS.lang);
  }

  switchLanguage(language: string) {
    this.loggingService.log('Switch Language Service => ', language);
    this.translocoService.setActiveLang(language);
    this.setLangState(language);
    // this.setLangStateIdb(language);
  }

  setLangState(lang: string) {
    this.storageService.set(LS.lang, lang);
  }

  switchLanguageIdb(language: string) {
    return this.setLangStateIdb(language).pipe(
      tap((result: boolean) => {
        this.loggingService.log('Set Lang in IndexedDB Result => ', result);
        this.translocoService.setActiveLang(language);
        this.setLangState(language);
      })
    );
  }

  getLangStateIdb(): Observable<IPreferences | undefined> {
    const deferred = defer(() => this.dexieDBService.preferences.get(1));
    return deferred;

    // const getLang = liveQuery(() => this.dexieDBService.preferences.get(1));
    // return getLang;
  }

  setLangStateIdb(lang: string) {
    // Implementation to set language state in IndexedDB
    const result = defer(() => this.dexieDBService.preferences.upsert(1, { language: lang }));
    return result;
  }
}
